import { useNavigate } from "react-router-dom";
import { ITicketData } from "../Services/ApiClient";
import { EventCheckMode, eventStore, IStoreGate } from "../Services/EventsStore";
import lmApiClient from "../Services/LmApiClient";
import session from "../Services/Session";
import { IUserSettings, userSettingsStore } from "../Services/UserSettingsStore";
import { useNetwork } from "./Network";


export function useActions() {

    const navigate = useNavigate();
    const network = useNetwork();

    const actions = {

        login() {

            navigate("/login");
        },

        settings() {

            navigate("/settings");
        },

        eventList(autoSelect = false) {

            navigate("/events", {
                state: {
                    autoSelect
                }
            });
        },

        ticketSearch(eventId: string, gateId: string) {

            navigate(`/search/${eventId}/${gateId}`);
        },

        offlineScans(eventId: string) {

            navigate(`/offline/${eventId}`);
        },


        async verifyApiUrlAsync() {

            if (!userSettingsStore.current.apiUrl || userSettingsStore.current.apiUrl == "") {

                try {
                    const settings = (await network(
                        () => lmApiClient.getDeviceLicenceSettingsAsync(session.deviceId))
                    ) as unknown as IUserSettings;
                    if (settings?.apiUrl) {
                        userSettingsStore.current.apiUrl = settings.apiUrl;
                        await userSettingsStore.saveAsync();
                    }

                }
                catch {
                    return false;
                }
            }
            return true;
        },

        async scanOrCountAsync(eventId: string, gate?: IStoreGate) {

            if (!gate) {

                if (!await network(async () => {

                    const gates = await eventStore.updateEventGatesAsync(eventId);

                    if (gates.length == 1)
                        gate = gates[0];

                    else {
                        actions.selectGate(eventId);
                        return false;
                    }

                    return true;
                })) {
                    return;
                }
            }

            session.activeGate = gate;

            const event = await eventStore.getEventByIdAsync(eventId);
            const verb = event.checkMode === EventCheckMode.Count ? "count" : "scan";
            let url = "/" + verb + "/" + eventId;
            if (gate)
                url += "/" + gate.code;

            navigate(url);
        },

        openMonitorAsync(eventId: string) {
            navigate("/monitor/" + eventId);
        },


        selectGate(eventId: string) {

            navigate("/gate/" + eventId);
        },


        scanHistory(eventId: string) {

            navigate("/scan/history/" + eventId);
        },

        ticketDetails(eventId: string, barcodeOrTicket: string | ITicketData) {

            const barcode = typeof barcodeOrTicket == "string" ? barcodeOrTicket : barcodeOrTicket.barcode;
            const ticket = typeof barcodeOrTicket == "string" ? null : barcodeOrTicket;

            navigate("/ticket/" + eventId + "/" + barcode, {
                state: {
                    ticket
                }
            });
        }
    }

    return actions;

}